export const FETCH_ORGANIZATIONS = 'FETCH_ORGANIZATIONS';
